/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { injectIntl } from 'react-intl'
import autoBind from 'react-autobind'
import { TextField as MaterialText } from 'material-ui'
import { grey800, red500 } from 'material-ui/styles/colors'
import InputMask from "react-input-mask"

import { isDisabled } from './fields'
import * as constants from './constants'
import 'resources/styles/applicant/Creation.css'

class TextField extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.field = null
  }

  setField (field) {
    if (this.props.getField && field) {
      this.props.getField(field.input)
    }
  }

  setFloatingLabelText (floatingLabelText, meta) {
    if (floatingLabelText && meta && meta.mandatory) {
      return [floatingLabelText, <span key={0} style={{color: red500, fontSize:20, verticalAlign:'sub'}}> *</span>]
    }

    return floatingLabelText
  }

  handleChange (e, value) {
    if (this.props.mask) {
      value = value.replaceAll('_', '')
    }

    if (value === '') {
      value = null
    }

    if (value &&
        this.props.type === 'number') {
      value = Number(value)
    }

    if (this.props.onChange) {
      this.props.onChange(e, value)
    }
  }

  render () {
    let { floatingLabelText, meta, mask, onChange, intl, getField, divStyle, messageMandatory, placeholderMandatory, ...rest } = this.props

    let componentProps = {
      disabled: isDisabled(meta),
      floatingLabelText: this.setFloatingLabelText(floatingLabelText, meta),
      ...rest
    }
    const disabled = componentProps.disabled

    return (
      <div
        style={
          divStyle
            ? divStyle
            : Object.assign(
                {
                  height: componentProps.multiLine
                    ? 'auto'
                    : 72
                },
                {
                  width: this.props.fullWidth
                    ? '100%'
                    : undefined
                }
              )
        }
      >
        <MaterialText
          floatingLabelFixed
          className={this.props.placeholderMandatory ? 'mandatory-placeholder' : ''}
          inputStyle={
            disabled ? {color: grey800} : null
          }
          fullWidth
          onChange={this.handleChange}
          errorStyle={{fontSize:10}}
          value={this.props.value}
          ref={this.setField}
          autoComplete='off'
          {
          ...componentProps
          }
          placeholder={
            placeholderMandatory
              ? this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)
              : this.props.placeholder
          }
        >
          {
            this.props.mask
              ? <InputMask
                name={this.props.name}
                mask={this.props.mask}
                value={this.props.value}
                maskChar="_"
                placeholder={
                  placeholderMandatory
                    ? this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)
                    : this.props.placeholder
                }
              />
              : undefined
          }
        </MaterialText>
        {
          meta &&
          meta.mandatory &&
          !placeholderMandatory &&
          !this.props.value &&
          !this.props.errorText
            ? <p className={'error-message'} style={{margin: 0}}>
                {messageMandatory || this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)}
              </p>
            : null
        }
      </div>
    )
  }
}

export default injectIntl(TextField)



// WEBPACK FOOTER //
// ./src/generic/form/TextField.js